<template>
	<div>
		<div class="d-flex justify-content-between">
			<h1 class="page-header">{{ $t('studentStatistic.pageTitle') }}</h1>
			<ts-breadcrumb :items="[
				{ text: $t('toHomePage'), href: '/' },
				{
					text: $t('studentStatistic.pageTitle'),
					active: true
				}
			]" />
		</div>
		<div class="row">
			<div class="col-md-3">
				<ts-card>
					<ts-card-wrapper>
						<ts-loading-banner :loading="loading">
							<form>
								<fieldset>
									<legend>{{ $t('studentStatistic.criteria') }}</legend>
									<div class="ts-space-y-4">
										<div class="row">
											<div class="col-md-12">
												<label class="ts-mb-0">
													{{ $t('studentStatistic.branch') }}
												</label>
												<a-select v-model="model.branch_id" :options="branches" mode="multiple"
													show-search option-filter-prop="children" class="ts-w-full"
													:class="{ 'is-invalid': errors.has('branch_id') }" placeholder="All"
													@change="onChangeBranch"></a-select>
												<div class="validate" v-if="errors.has('branch_id')">
													{{ errors.first('branch_id') }}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12">
												<label class="ts-mb-0">
													{{ $t('studentStatistic.mainProgram') }}
												</label>
												<a-select v-model="model.acp_id" :options="mainProgram" mode="multiple"
													show-search option-filter-prop="children" class="ts-w-full"
													:class="{ 'is-invalid': errors.has('acp_id') }" placeholder="All"
													@change="onChangeMainProgram"></a-select>
												<div class="validate" v-if="errors.has('acp_id')">
													{{ errors.first('acp_id') }}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12">
												<label class="ts-mb-0">
													{{ $t('studentStatistic.subProgram') }}
												</label>
												<a-select v-model="model.acps_id" :options="subProgram" mode="multiple"
													show-search option-filter-prop="children" class="ts-w-full"
													:class="{ 'is-invalid': errors.has('acps_id') }" placeholder="All"
													@change="onChangeSubProgram"></a-select>
												<div class="validate" v-if="errors.has('acps_id')">
													{{ errors.first('acps_id') }}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12">
												<label class="ts-mb-0 required">
													{{ $t('studentStatistic.academicYear') }}
												</label>
												<a-select v-model="model.ac_year_id" :options="academicYear" show-search
													option-filter-prop="children" class="ts-w-full"
													:class="{ 'is-invalid': errors.has('ac_year_id') }"
													placeholder="All" @change="onChangeAcademicYear"></a-select>
												<div class="validate" v-if="errors.has('ac_year_id')">
													{{ errors.first('ac_year_id') }}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12">
												<label class="ts-mb-0">
													{{ $t('studentStatistic.academicTerm') }}
												</label>
												<a-select v-model="model.ac_term_id" :options="academicTerm"
													mode="multiple" show-search option-filter-prop="children"
													class="ts-w-full"
													:class="{ 'is-invalid': errors.has('ac_term_id') }"
													placeholder="All" @change="onChangeAcademicTerm"></a-select>
												<div class="validate" v-if="errors.has('ac_term_id')">
													{{ errors.first('ac_term_id') }}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12">
												<label class="ts-mb-0">
													{{ $t('studentStatistic.studyTime') }}
												</label>
												<a-select v-model="model.ac_st_id" :options="studyTime" mode="multiple"
													show-search option-filter-prop="children" class="ts-w-full"
													:class="{ 'is-invalid': errors.has('ac_st_id') }" placeholder="All"
													@change="onChangeStudyTime"></a-select>
												<div class="validate" v-if="errors.has('ac_st_id')">
													{{ errors.first('ac_st_id') }}
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12">
												<label class="ts-mb-0">
													{{ $t('studentStatistic.academicClass') }}
												</label>
												<a-select v-model="model.class_id" :options="academicClass"
													mode="multiple" show-search option-filter-prop="children"
													class="ts-w-full" :class="{ 'is-invalid': errors.has('class_id') }"
													placeholder="All"></a-select>
												<div class="validate" v-if="errors.has('class_id')">
													{{ errors.first('class_id') }}
												</div>
											</div>
										</div>
										<div class="row">
											<!-- <div class="col-md-6 text-right">
												<ts-button class="btn-block" outline color="success"
													@click.prevent="exportExcel" :waiting="exporting">{{
														$t('excel') }}</ts-button>
											</div> -->
											<div class="col-md-12 text-right">
												<ts-button class="btn-block" color="primary" @click.prevent="preview"
													:waiting="waiting" :disabled="waiting">{{ $t('preview')
													}}</ts-button>
											</div>
										</div>
									</div>
								</fieldset>
							</form>
						</ts-loading-banner>
					</ts-card-wrapper>
				</ts-card>
			</div>
			<div class="col-md-9">
				<ts-card>
					<ts-card-wrapper>
						<form>
							<fieldset>
								<legend>{{ $t('infoInquiry.preview') }}</legend>
								<ts-preview-pdf v-model="waiting" :src="src" />
							</fieldset>
						</form>
					</ts-card-wrapper>
				</ts-card>
			</div>
		</div>
	</div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	name: 'infoInquiry',
	data() {
		return {
			loading: false,
			waiting: false,
			exporting: false,
			src: '',
			errors: new Errors(),
			model: {
				branch_id: [],
				acp_id: [],
				acps_id: [],
				ac_year_id: null,
				ac_term_id: [],
				class_id: [],
				ac_st_id: [],
			}
		}
	},
	created() {
		this.getPreData({
			params: {},
			index: undefined
		})
	},
	computed: {
		...mapState('studentStatistic', ['formViewDatas']),
		branches() {
			if (this.formViewDatas['branches']) {
				return this.formViewDatas['branches']
					.map(el => ({
						value: el.branch_id,
						label: el.branch_name_en
					}))
			}
			return []
		},
		mainProgram() {
			if (this.formViewDatas['mainProgram']) {
				return this.formViewDatas['mainProgram']
					.map(el => ({
						value: el.acp_id,
						label: el.acp_name_foreign
					}))
			}
			return []
		},
		subProgram() {
			if (this.formViewDatas['subProgram']) {
				return this.formViewDatas['subProgram']
					.filter(el =>
						this.model.acp_id.length > 0 ? _.includes(this.model.acp_id, el.acp_id) : true
					)
					.map(el => ({
						value: el.acps_id,
						label: el.acps_name_foreign
					}))
			}
			return []
		},
		academicYear() {
			if (this.formViewDatas['academicYear']) {
				return this.formViewDatas['academicYear']
					.filter(el =>
						this.model.branch_id.length > 0 ? _.includes(this.model.branch_id, el.branch_id) : true
					).map(el => ({
						value: el.ac_year_id,
						label: el.ac_year + ' ( ' + el.ac_status + ' )'
					}))
			}
			return []
		},
		academicTerm() {
			if (this.formViewDatas['academicTerm']) {
				return this.formViewDatas['academicTerm']
					.filter(el =>
						this.model.branch_id.length > 0 ? _.includes(this.model.branch_id, el.branch_id) : true
					)
					.filter(el =>
						this.model.acps_id.length > 0 ? _.includes(this.model.acps_id, el.acps_id) : true
					)
					.filter(el =>
						this.model.ac_year_id ? this.model.ac_year_id == el.ac_year_id : true
					)
					.map(el => ({
						value: el.ac_term_id,
						label: el.term_name + ' ( ' + el.ac_status + ' )'
					}))
			}
			return []
		},
		studyTime() {
			if (this.formViewDatas['studyTime']) {
				return this.formViewDatas['studyTime']
					.map(el => ({
						value: el.ac_st_id,
						label: el.study_time
					}))
			}
			return []
		},
		academicClass() {
			if (this.formViewDatas['academicClass']) {
				return this.formViewDatas['academicClass']
					.filter(el =>
						this.model.branch_id.length > 0 ? _.includes(this.model.branch_id, el.branch_id) : true
					)
					.filter(el =>
						this.model.acp_id.length > 0 ? _.includes(this.model.acp_id, el.acp_id) : true
					)
					.filter(el =>
						this.model.acps_id.length > 0 ? _.includes(this.model.acps_id, el.acps_id) : true
					)
					.filter(el =>
						this.model.ac_year_id ? this.model.ac_year_id == el.ac_year_id : true
					)
					.filter(el =>
						this.model.ac_term_id.length > 0 ? _.includes(this.model.ac_term_id, el.ac_term_id) : true
					)
					.filter(el =>
						this.model.ac_st_id.length > 0 ? _.includes(this.model.ac_st_id, el.ac_st_id) : true
					)
					.map(el => ({
						value: el.class_id,
						label: el.class_name + ' | ' + el.teacher_name_foreign + ' | ' + el.study_time,
					}))
			}
			return []
		},

	},
	methods: {
		...mapActions('studentStatistic', ['getFormViewModel', 'previewPdf', 'exportExcel']),
		onChangeBranch(value) {
			this.model.ac_term_id = []
			this.model.class_id = []
		},
		onChangeMainProgram(value) {
			this.model.acps_id = []
			this.model.ac_term_id = []
			this.model.class_id = []
		},
		onChangeSubProgram(value) {
			this.model.ac_term_id = []
			this.model.class_id = []
		},
		onChangeAcademicYear(value) {
			this.model.ac_term_id = []
			this.model.class_id = []
		},
		onChangeAcademicTerm(value) {
			this.model.class_id = []
		},
		onChangeStudyTime(value) {
			this.model.class_id = []
		},
		async getPreData({ params, index }) {
			this.loading = true
			await this.getFormViewModel({ index: index, params: params }).then(response => {
				let ac_year = response.data.academicYear.find(el => el.ac_status_id == 1)
				this.model.ac_year_id = ac_year.ac_year_id
				this.model.branch_id = [this.$store.state.authUser.default_branch_id]
			})
			this.loading = false
		},
		preview() {
			this.waiting = true
			this.src = ''
			this.errors = new Errors()
			this.previewPdf(this.model)
				.then(response => {
					this.src = response.data.url
				})
				.catch(error => {
					this.$toasted.error(error.response.data.message)
					this.errors = new Errors(error.response.data.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		exportExcel() {
			this.errors = new Errors()
			this.exporting = true
			this.$store
				.dispatch(
					'reportAcademic/infoInquiryExcelRawData',
					this.model
				)
				.then(response => {
					const anchor = document.createElement('a');
					anchor.href = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURI(response.data);
					anchor.target = '_blank';
					anchor.download = 'report-inquiry-list.csv';
					anchor.click();
				})
				.catch(err => {
					let error = JSON.parse(
						String.fromCharCode.apply(null, new Uint8Array(err))
					)
					this.notice({ type: 'error', text: error.message })
					this.errors = new Errors(error.errors)
				})
				.finally(() => (this.exporting = false))
		},
	}
}
</script>
